import { useState, useRef, useEffect } from 'react'

export const useSyncState = (initVal: any) => {
  const [state, setState] = useState(initVal)
  const current = useRef(initVal)

  useEffect(() => {
    current.current = state
  }, [state])

  // 返回一个数组
  return [state, setState, current]
}
// 注：使用上面的current时，要跟ref()用法一样，通过current.current才能获取到值
